export const CREATE_PROJECT_START = 'CREATE_PROJECT_START';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_FAILURE = 'CREATE_PROJECT_FAILURE';
export const UPDATE_PROJECT_START = 'UPDATE_PROJECT_START';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_FAILURE = 'UPDATE_PROJECT_FAILURE';
export const FETCH_PROJECT_START = 'FETCH_PROJECT_START';
export const FETCH_PROJECT_SUCCESS = 'FETCH_PROJECT_SUCCESS';
export const FETCH_ALL_PROJECT_SUCCESS = 'FETCH_ALL_PROJECT_SUCCESS';
export const FETCH_PROJECT_FAILURE = 'FETCH_PROJECT_FAILURE';
export const SET_PROJECTS_INIT = 'SET_PROJECTS_INIT';
export const LOADING = 'LOADING';
export const SUCCESS = 'SUCCESS';
export const UPDATED = 'UPDATED';
export const FETCHPROJS = 'FETCHPROJS';
export const ERROR = 'ERROR';
export const INIT = 'INIT';
export const COPIED = 'COPIED';
export const COPY_PROJECT_START = 'COPY_PROJECT_START';
export const COPY_PROJECT_SUCCESS = 'COPY_PROJECT_SUCCESS';
export const COPY_PROJECT_FAILURE = 'COPY_PROJECT_FAILURE';
export const FETCH_MASTER_PROJECT_START = 'FETCH_MASTER_PROJECT_START';
export const FETCH_MASTER_PROJECT_SUCCESS = 'FETCH_MASTER_PROJECT_SUCCESS';
export const FETCH_MASTER_PROJECT_FAILURE = 'FETCH_MASTER_PROJECT_FAILURE';
export const FETCH_PACKAGE_START = 'FETCH_PACKAGE_START';
export const FETCH_PACKAGE_SUCCESS = 'FETCH_PACKAGE_SUCCESS';
export const FETCH_PACKAGE_FAILURE = 'FETCH_PACKAGE_FAILURE';
export const CREATE_PACKAGE_START = 'CREATE_PACKAGE_START';
export const CREATE_PACKAGE_SUCCESS = 'CREATE_PACKAGE_SUCCESS';
export const CREATE_PACKAGE_FAILURE = 'CREATE_PACKAGE_FAILURE';
export const CREATE_TAG_START = 'CREATE_TAG_START';
export const CREATE_TAG_SUCCESS = 'CREATE_TAG_SUCCESS';
export const CREATE_TAG_FAILURE = 'CREATE_TAG_FAILURE';
export const RESET_PKGS_TAGS = 'RESET_PKGS_TAGS';
export const FETCH_TAGS_START = 'FETCH_TAGS_START';
export const FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS';
export const FETCH_TAGS_FAILURE = 'FETCH_TAGS_FAILURE';
export const CREATE_TAGS_START = 'CREATE_PACKAGE_START';
export const SWITCH_PKG_TAGS = 'SWITCH_PKG_TAGS';
export const SWITCH_TAG_PKG = 'SWITCH_TAG_PKG';
export const UPDATE_TAGS_START = 'UPDATE_TAGS_START';
export const UPDATE_TAGS_SUCCESS = 'UPDATE_TAGS_SUCCESS';
export const UPDATE_TAGS_FAILURE = 'UPDATE_TAGS_FAILURE';
export const UPDATE_TAGS_RESPONSE = 'UPDATE_TAGS_RESPONSE';
export const DELETE_TAGS_RESPONSE = 'DELETE_TAGS_RESPONSE';
export const FETCH_ADNAMES_START = 'FETCH_ADNAMES_START';
export const FETCH_ADNAMES_SUCCESS = 'FETCH_ADNAMES_SUCCESS';
export const FETCH_ADNAMES_FAILURE = 'FETCH_ADNAMES_FAILURE';
export const CREATE_PKG_START = 'CREATE_PKG_START';
export const CREATE_PKG_SUCCESS = 'CREATE_PKG_SUCCESS';
export const CREATE_PKG_FAILURE = 'CREATE_PKG_FAILURE';
export const FETCH_PKGS_START = 'FETCH_PKGS_START';
export const FETCH_PKGS_SUCCESS = 'FETCH_PKGS_SUCCESS';
export const FETCH_PKGS_FAILURE = 'FETCH_PKGS_FAILURE';
export const UPDATE_PKG_START = 'UPDATE_PKG_START';
export const RESET_TAGS = 'RESET_TAGS';
export const PKGS_UPDATE_STATUS = 'PKGS_UPDATE_STATUS';

export const UPDATE_PKG_SUCCESS = 'UPDATE_PKG_SUCCESS';
export const UPDATE_PKG_FAILURE = 'UPDATE_PKG_FAILURE';
export const HIDE_PKG_NAV = 'HIDE_PKG_NAV';
export const CREATE_TTYPE_START = 'CREATE_TTYPE_START';
export const CREATE_TTYPE_SUCCESS = 'CREATE_TTYPE_SUCCESS';
export const CREATE_TTYPE_FAILURE = 'CREATE_TTYPE_FAILURE';
export const SWITCH_TTYPES = 'SWITCH_TTYPES';
export const FETCH_TTYPES_START = 'FETCH_TTYPES_START';
export const FETCH_TTYPES_SUCCESS = 'FETCH_TTYPES_SUCCESS';
export const FETCH_TTYPES_FAILURE = 'FETCH_TTYPES_FAILURE';
export const SWITCH_TAG_TT = 'SWITCH_TAG_TT';
export const SWITCH_TT_TAG = 'SWITCH_TT_TAG';
export const SWITCH_CATEGORY_TAGS = 'SWITCH_CATEGORY_TAGS';
export const SWITCH_INSTYPE_TAGS = 'SWITCH_INSTYPE_TAGS'
export const SWITCH_DATASET = 'SWITCH_DATASET';
export const SWITCH_DATASET_CHILD = 'SWITCH_DATASET_CHILD';
export const MERGE_IMPORTED_TAGS = 'MERGE_IMPORTED_TAGS';

export const FETCH_TAG_COUNT_START = 'FETCH_TAG_COUNT_START';
export const FETCH_TAG_COUNT_SUCCESS = 'FETCH_TAG_COUNT_SUCCESS';
export const FETCH_TAG_COUNT_FAILURE = 'FETCH_TAG_COUNT_FAILURE';

export const UPDATE_PROGRESS_COUNT = 'UPDATE_PROGRESS_COUNT';
export const SHOW_PROGRESS_BAR = 'SHOW_PROGRESS_BAR';
export const FETCH_TAGS_CANCEL = 'FETCH_TAGS_CANCEL';
export const FETCH_ARCHIVE_CANCEL = 'FETCH_ARCHIVE_CANCEL';

export const HIDE_PROGRESS_BAR = 'HIDE_PROGRESS_BAR';
export const COPY_TAGS_START = 'COPY_TAGS_START';
export const COPY_TAGS_SUCCESS = 'COPY_TAGS_SUCCESS';
export const COPY_TAGS_FAILURE = 'COPY_TAGS_FAILURE';

export const REFRESH_TAGS_STATUS = 'REFRESH_TAGS_STATUS';

export const REMOVE_TAGS_START = 'REMOVE_TAGS_START';
export const REMOVE_TAGS_SUCCESS = 'REMOVE_TAGS_SUCCESS';
export const REMOVE_TAGS_FAILURE = 'REMOVE_TAGS_FAILURE';
// getmodelbreak
export const FETCH_MODEL_BREAK_START = 'FETCH_MODEL_BREAK_START';
export const FETCH_MODEL_BREAK_SUCCESS = 'FETCH_MODEL_BREAK_SUCCESS';
export const FETCH_MODEL_BREAK_FAILURE = 'FETCH_MODEL_BREAK_FAILURE';
//getmodelbreakmultitag
export const FETCH_MODEL_BREAK_MUL_START = 'FETCH_MODEL_BREAK_MUL_START';
export const FETCH_MODEL_BREAK_MUL_SUCCESS = 'FETCH_MODEL_BREAK_MUL_SUCCESS';
export const FETCH_MODEL_BREAK_MUL_FAILURE = 'FETCH_MODEL_BREAK_MUL_FAILURE';

//action for add update price config
export const ADD_UPDATE_PRICE_CONFIG = 'ADD_UPDATE_PRICE_CONFIG';
export const ADD_UPDATE_PRICE_CONFIG_SUCCESS = 'ADD_UPDATE_PRICE_CONFIG_SUCCESS';
export const ADD_UPDATE_PRICE_CONFIG_FAILURE = 'ADD_UPDATE_PRICE_CONFIG_FAILURE';

export const USER_EXPIRE_LOGOUT = 'USER_EXPIRE_LOGOUT';

export const GET_REPORT_START = 'GET_REPORT_START';
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
export const GET_REPORT_FAILURE = 'GET_REPORT_FAILURE';
export const REPORT_BATCHES_START = 'REPORT_BATCHES_START';
export const REPORT_BATCHES_SUCCESS = 'REPORT_BATCHES_SUCCESS';
export const REPORT_BATCHES_FAILURE = 'REPORT_BATCHES_FAILURE';
export const REPORT_BATCHES_RESET = 'REPORT_BATCHES_RESET';
export const START_LOADER = 'START_LOADER';
export const STOP_LOADER = 'STOP_LOADER';


export const DELETE_TAGS_START = 'DELETE_TAGS_START';
export const RESTORE_TAGS_START = 'RESTORE_TAGS_START';
export const FETCH_REPORT_HUB_STATUS_START = 'FETCH_REPORT_HUB_STATUS_START';
export const FETCH_REPORT_HUB_STATUS_SUCCESS = 'FETCH_REPORT_HUB_STATUS_SUCCESS';
export const FETCH_REPORT_HUB_STATUS_FAILURE = 'FETCH_REPORT_HUB_STATUS_FAILURE';

export const CLEAR_REPORT_HUB_STATUS = 'CLEAR_REPORT_HUB_STATUS';

export const REPORTHUB_TASK_STATUS_START = 'REPORTHUB_TASK_STATUS_START';

export const REPORTHUB_TASK_STATUS_UPDATE = 'REPORTHUB_TASK_STATUS_UPDATE';

export const SEND_MAIL_START = 'SEND_MAIL_START';
export const SEND_MAIL_SUCCESS = 'SEND_MAIL_SUCCESS';
export const SEND_MAIL_FAILURE = 'SEND_MAIL_FAILURE';

export const COPY_PKG_INIT = 'COPY_PKG_INIT';
export const COPY_PKG_SUCCESS = 'COPY_PKG_SUCCESS';

export const BULK_TAG_CONFIG_START = 'BULK_TAG_CONFIG_START';
export const BULK_TAG_CONFIG_SUCCESS = 'BULK_TAG_CONFIG_SUCCESS';
export const BULK_TAG_CONFIG_FAILURE = 'BULK_TAG_CONFIG_FAILURE';

export const BULK_TAG_CONFIG_STS_START = 'BULK_TAG_CONFIG_STS_START';
export const BULK_TAG_CONFIG_STS_SUCCESS = 'BULK_TAG_CONFIG_STS_SUCCESS';
export const BULK_TAG_CONFIG_STS_FAILURE = 'BULK_TAG_CONFIG_STS_FAILURE';

export const BULK_TAG_CONFIG_CANCEL_START = 'BULK_TAG_CONFIG_CANCEL_START';
export const BULK_TAG_CONFIG_CANCEL_SUCCESS = 'BULK_TAG_CONFIG_CANCEL_SUCCESS';
export const BULK_TAG_CONFIG_CANCEL_FAILURE = 'BULK_TAG_CONFIG_CANCEL_FAILURE';
export const CHANGE_LOADING_PHASE_STS = 'CHANGE_LOADING_PHASE_STS';

export const SEND_PRICING_DATA_START = 'SEND_PRICING_DATA_START';
export const SEND_PRICING_DATA_SUCCESS = 'SEND_PRICING_DATA_SUCCESS';
export const SEND_PRICING_DATA_FAILURE = 'SEND_PRICING_DATA_FAILURE';

export const FETCH_TAG_COUNT_PKG_START = 'FETCH_TAG_COUNT_PKG_START';
export const FETCH_TAG_COUNT_PKG_SUCCESS = 'FETCH_TAG_COUNT_PKG_SUCCESS';
export const FETCH_TAG_COUNT_PKG_FAILURE = 'FETCH_TAG_COUNT_PKG_FAILURE';

export const PRICE_ITEM_START = 'PRICE_ITEM_START';
export const PRICE_ITEM_SUCCESS = 'PRICE_ITEM_SUCCESS';
export const PRICE_ITEM_FAILURE = 'PRICE_ITEM_FAILURE';

export const ITEM_PRICE_STS_START = 'ITEM_PRICE_STS_START';
export const ITEM_PRICE_STS_SUCCESS = 'ITEM_PRICE_STS_SUCCESS';
export const ITEM_PRICE_STS_FAILURE = 'ITEM_PRICE_STS_FAILURE';

export const QUOTE_SEARCH_START = 'QUOTE_SEARCH_START';
export const QUOTE_SEARCH_SUCCESS = 'QUOTE_SEARCH_SUCCESS';
export const QUOTE_SEARCH_FAILURE = 'QUOTE_SEARCH_FAILURE';
export const CLEAR_QUOTE_SEARCH = 'CLEAR_QUOTE_SEARCH';

export const FETCH_TAGS_WITH_CMNT_START = 'FETCH_TAGS_WITH_CMNT_START';
export const FETCH_TAGS_WITH_CMNT_SUCCESS = 'FETCH_TAGS_WITH_CMNT_SUCCESS';
export const FETCH_TAGS_WITH_CMNT_FAILURE = 'FETCH_TAGS_WITH_CMNT_FAILURE';
export const CLEAR_TAGS_WITH_CMNT = 'CLEAR_TAGS_WITH_CMNT';

export const FETCH_PKG_CMT_HISTORY_START = 'FETCH_PKG_CMT_HISTORY_START';
export const FETCH_PKG_CMT_HISTORY_SUCCESS = 'FETCH_PKG_CMT_HISTORY_SUCCESS';
export const FETCH_PKG_CMT_HISTORY_FAILURE = 'FETCH_PKG_CMT_HISTORY_FAILURE';

export const UPDATE_PKG_CMT_START = 'UPDATE_PKG_CMT_START';
export const UPDATE_PKG_CMT_SUCCESS = 'UPDATE_PKG_CMT_SUCCESS';
export const UPDATE_PKG_CMT_FAILURE = 'UPDATE_PKG_CMT_FAILURE';
export const UPDATE_PKG_CMT_DELETE = 'UPDATE_PKG_CMT_DELETE';

export const EDIT_PKG_CMT_START = 'EDIT_PKG_CMT_START';
export const EDIT_PKG_CMT_SUCCESS = 'EDIT_PKG_CMT_SUCCESS';
export const EDIT_PKG_CMT_FAILURE = 'EDIT_PKG_CMT_FAILURE';

export const CONF_IT_MODEL_STRING_BREAKDOWN_START = 'CONF_IT_MODEL_STRING_BREAKDOWN_START';
export const CONF_IT_MODEL_STRING_BREAKDOWN_SUCCESS = 'CONF_IT_MODEL_STRING_BREAKDOWN_SUCCESS';
export const CONF_IT_MODEL_STRING_BREAKDOWN_FAILURE = 'CONF_IT_MODEL_STRING_BREAKDOWN_FAILURE';